const gif = document.getElementById('myGif');

const removeGif = () => {
    gif.remove();
};

// Check if the GIF has been displayed this session
if (!sessionStorage.getItem('gifDisplayed')) {
    gif.classList.remove('hidden');
    // Set the GIF as displayed for this session
    sessionStorage.setItem('gifDisplayed', 'true');

    // Remove the GIF after its duration (assuming 5 seconds here)
    setTimeout(removeGif, 3000);
} else {
    // If the GIF has been displayed this session, remove it immediately
    removeGif();
}

